import {
  CircularProgress,
  Dialog,
  DialogContent,
  type DialogProps,
  Flex,
  Text,
} from '@shared/components';

export type RetireExamCenterRoomLoadingModalProps = Pick<DialogProps, 'open'>;

export default function RetireExamCenterRoomLoadingModal(
  props: Readonly<RetireExamCenterRoomLoadingModalProps>,
) {
  const { open: isOpen } = props;
  return (
    <Dialog open={isOpen} sx={{ '& .MuiPaper-root': { width: '378px' } }}>
      <DialogContent
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: theme.spacing(4),
        })}
      >
        <CircularProgress />
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(1), textAlign: 'center' })}
        >
          <Text variant='h5'>กำลังตรวจสอบการใช้งาน</Text>
          <Text color='secondary'>กรุณารอสักครู่ ระบบกำลังตรวจสอบข้อมูลการใช้งานสถานที่</Text>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
